var ApiCall = {
  PING: "Ping",
  PING_LEGACY: "ping",
  LOGIN: "LoginUser",
  LOGOUT: "LogoutUser",
  LOGIN_PLAYER: "PlayerLoginLocal",
  LOGOUT_PLAYER: "PlayerLogoutOnline",
  GET_CODE_PLAYER_LOGIN: "PlayerLoginLocalGetCode",
  GET_TRACKS: "getTracks",
  GET_RACES: "getRaces",
  GET_ENTRIES: "getEntries",
  GET_STATISTICS: "GetStatistics",
  TICKET_VALIDATOR: "ticketvalidator",
  GET_DB_DATE_SERVER: "GetDBServerTime",
  GET_RESULTS: "getResults",
  GET_OPEN_BETS: "GetOpenBets",
  GET_HISTORY_SUMMARY: "GetPlayerHistorySummaryLocal",
  GET_HISTORY_TRANSAC: "GetPlayerHistoryLocal",
  VOID: "ticketvoid",
  GET_MY_IP: "GetMyIP",
  GET_STAKE: "GetStake",
  INVOKEMETHOD: "InvokeMethod",
  INVOKE_GET_METHOD: "InvokeGetMethod",
  GET_WAGER_GUID: "GetWagerGUID",
  INTERNAL_GET_OPEN_BETS: "Internal/GetOpenBets",
  GET_WAGER_DETAILS: "Internal/GetWagerDetails",
  GET_INTERNAL_SUMMARY: "Internal/GetSummaryforClient",
  GET_INTERNAL_HISTORY: "Internal/GetHistoryforClient",
  GET_TRANSACTION_DETAILS: "Internal/GetTransactionDetails",
  GET_HISTORY_ACTION_DETAILS: "Internal/GetActionDetails",
  GET_OPEN_BETS_DETAILS: "Internal/GetOpenBetsDetails",
  ONLINE_RESET_USER_PASSWORD: "OnlineResetUserPassword",
  GET_VOID_REASON_LIST: "GetVoidReasonList",
  VOID_WAGER_LIST: "voidwagerlist",
};

export default ApiCall;
